export default __webpack_public_path__ + "static/media/pass_bg.a0a13d1d.png";